import PdfStrategy from '../Strategy/PdfStrategy'

export default class PdfTicketContext {
    public execute(strategy: PdfStrategy, clientName: string, value: string) {
        if (!strategy) {
            throw new Error('Context no definido')
        }
        return strategy.getTicket(clientName, value)
    }
}